import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

export const unauthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (u) {
    return router.createUrlTree(['/']);
  }

  return true;
};
